/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2020-11-30 18:57:40
 */

import AlarmQuery from '../alarmQuery';
import { ColDefCustom, default as AgGridVueCustomTsx } from 'src/components/agGridCustom/agGridVueCustomTsx';
import AlarmQueryApi, { AlarmQueryDOI } from '../api/alarmQueryApi';
import ListPageService from 'src/types/ListPage';
import override from 'src/dectorators/override';
import {QueryFormVOI} from "../../../../components/queryForm/queryForm";
import DatePicker from "../../../../types/iview/DatePicker";
import {DateTimeUtil} from "../../../../util/dateTimeUtil";

export default class AlarmQueryService extends ListPageService {
    ctx: AlarmQuery;
    type: any;

    constructor(ctx: AlarmQuery) {
        super();
        this.ctx = ctx;
    }

    @override
    createColumns(): ColDefCustom[] {
        return [
            {
                headerName: '报警名称',
                field: 'alarm_data',
                minWidth: 80,
            },
            {
                headerName: 'mn号',
                field: 'mn',
                minWidth: 100,
            },
            {
                headerName: '报警时间',
                field: 'create_time',
                minWidth: 140,
            },
        ];
    }

    @override
    creatQueryForm(): QueryFormVOI.DateItemType[] {
        return [
            {
                component: DatePicker,
                label: '时间',
                labelWidth: 40,
                width: 250,
                field: 'time',
                // timeType: 'number',
                realField: ['start_time', 'end_time'],
                props: {
                    value: DateTimeUtil.getDayInterval(7),
                    type: 'daterange',
                    options: {
                        shortcuts: [
                            {
                                text: '最近1天',
                                value() {
                                    return DateTimeUtil.getDayInterval(1);
                                },
                            },
                            {
                                text: '最近7天',
                                value() {
                                    return DateTimeUtil.getDayInterval(7);
                                },
                            },
                            {
                                text: '最近30天',
                                value() {
                                    return DateTimeUtil.getDayInterval(30);
                                },
                            },
                        ],
                    },
                    placeholder: '请选择时间',
                },
            },
        ];
    }

    @override
    initSearchParams(): void {
        this.ctx.searchParams = this.ctx.queryForm.getQueryObj<AlarmQueryDOI.QueryRowDataParamsI>();
        this.ctx.currentPage = 1;
    }

    @override
    async searchTable() {
        let ctx = this.ctx;
        let ag = this.ctx.$refs.ag as AgGridVueCustomTsx;
        ag.showLoading();
        let { code, data } = await AlarmQueryApi.listAlarmPage({
            ...ctx.searchParams,
            page_size: ctx.pageSize,
            page_index: ctx.currentPage,
        });
        ag.hideLoading();

        if (code === 0) {
            ctx.rowData = data.data_info || [];
            ctx.total = data.page_count;
        }
    }
}
